import { Caption } from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import { useGetStartedAction } from '~/modules/design-board/hook';
import * as S from '~/modules/design-board/component/board-list/NoBoardState.style';

const NoBoardState = () => {
    const { css } = useStyles();

    const { isLoggedIn, getStartedButton } = useGetStartedAction();

    const extraText = isLoggedIn
        ? 'Get started by creating your first board.'
        : 'Sign up now to create your first board.';

    return (
        <div className={css(S.NoBoardState)}>
            <div className={css(S.NoBoardStateContent)}>
                <Caption>
                    Simplify your project with design boards.{' '}
                    <span>
                        Save what you love, select products, engage
                        professionals and keep track of your project from
                        concept to completion.
                    </span>
                </Caption>
                <Caption>{extraText}</Caption>
            </div>

            {getStartedButton}
        </div>
    );
};

export default NoBoardState;
